export const applicationId = '5a9af8cd-2890-4637-b4f2-70641a759a9b';

// export const UNO_URL = 'http://localhost:3003';
// export const UNO_URL = 'https://simulanisiwa-d5geabhfgabecxgq.centralindia-01.azurewebsites.net';
// export const UNO_URL = 'https://api.simulanis.io';
export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';
// export const UNO_URL = 'https://usermanagement-behcg9a8d0fdgbfn.centralindia-01.azurewebsites.net';

export const SSO_URL = 'https://sso.simulanis.io';